import { isValidCron } from 'cron-validator';

// https://ankrnetwork.atlassian.net/browse/AUTO-63
export function isValidCronExpression(expression: string): boolean | string {
  const isBaseValid = isValidCron(expression);
  if (!isBaseValid) {
    return false;
  }

  const expressionItems = expression.trim().split(' ').filter(Boolean);

  return expressionItems.every(item => {
    const characters = item.match(/[,\-/]/gm);
    const { size } = new Set(characters);

    return size <= 1;
  });
}
